import React from 'react'

import agent from 'agent'
import ConfirmationModal from 'components/common/ConfirmationModal'
import Text from 'components/common/Text'
import toast from 'lib/toast'
import { ApiKey } from 'types/api/api-key'
import { messageFromResponseError } from 'utils/strings'

const RevokeApiKeyModal: React.FC<{
  isOpen: boolean
  setOpenState: React.Dispatch<React.SetStateAction<boolean>>
  apiKey: ApiKey
  fetchApiKeys: () => void
}> = ({ isOpen, setOpenState, apiKey, fetchApiKeys }) => {
  return (
    <ConfirmationModal
      confirmText="Revoke"
      message={
        <Text>
          <b>{apiKey.identifier}</b> will be deactivated and access from all
          Gremlin resources will be revoked.
        </Text>
      }
      open={isOpen}
      title="Revoke API Key"
      onCancel={() => setOpenState(false)}
      onConfirm={async () => {
        setOpenState(false)

        try {
          await agent.delete(
            `/apikeys/${encodeURIComponent(apiKey.identifier)}`
          )

          fetchApiKeys()
          toast({
            type: 'success',
            text: `Revoked '${apiKey.identifier}' API Key`
          })
        } catch (err) {
          toast({
            type: 'error',
            text: messageFromResponseError(
              err,
              `There was an issue revoking '${apiKey.identifier}' API Key. Please try again later.`
            )
          })
        }
      }}
    />
  )
}

export default RevokeApiKeyModal
